import utils from 'gkCon/utils'

export default {
  ...utils
}
